import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex flex-col items-center md:items-start gap-2">
            <Link to="/" className="font-heading text-xl font-bold text-primary-600 whitespace-nowrap cursor-pointer">
              久久热
            </Link>
            <p className="text-sm text-foreground-600 text-center md:text-left">
              发现热门，追踪趋势 — 您的每日精彩内容伴侣
            </p>
          </div>

          <div className="flex items-center gap-6 text-sm text-foreground-600">
            <Link to="/about" className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              关于久久热
            </Link>
            <a href="#" className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              隐私政策
            </a>
            <a href="#" className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              服务条款
            </a>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500 text-center sm:text-left">
            &copy; 2026 久久热 Jiujiure.com 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            用心精选每一篇内容，陪您享受每一刻精彩
          </p>
        </div>
      </div>
    </footer>
  );
}